import {
    getAddMessage,
    getMultiSelectMessage,
    getNumMinMessage,
    getReqMessage
} from '../../../utils/formValidation/errorMessageFunctions';

export const validateDirectusLists = (appointmentTypes, userEventTypes) => {
    let newErrors = {};

    if (appointmentTypes.length < 1) {
        newErrors = {
            ...newErrors,
            appointmentTypes: { error: true, message: getMultiSelectMessage('appointment type') }
        };
    }
    if (userEventTypes.length < 1) {
        newErrors = {
            ...newErrors,
            userEventTypes: { error: true, message: getMultiSelectMessage('user event type') }
        };
    }
    return newErrors;
};

export const validateConstants = (constants) => {
    let newErrors = {};

    if (
        constants.displayInitialAppointmentAccordion &&
        constants.initialAppointmentFields.length < 1
    ) {
        newErrors = {
            ...newErrors,
            initialAppointmentFields: {
                error: true,
                message: getMultiSelectMessage('initial appointment field')
            }
        };
    }

    constants.automaticAppointments.forEach((el) => {
        if (!('triggers' in el) || el.triggers.length < 1) {
            newErrors = {
                ...newErrors,
                [`automaticAppointment-${el.id}`]: {
                    error: true,
                    message: getAddMessage('trigger')
                },
                [`accordion-${el.id}`]: { error: true }
            };
        } else if (el.triggers?.length) {
            el.triggers.forEach((entry) => {
                if (!entry.triggerAppointmentTypeId) {
                    newErrors = {
                        ...newErrors,
                        [`automaticAppointment-${el.id}-triggerAppointmentTypeId-${entry.id}`]: {
                            error: true,
                            message: getReqMessage('Trigger appointment type')
                        },
                        [`accordion-${el.id}`]: { error: true }
                    };
                }
                if (!entry.triggerAfterDays) {
                    newErrors = {
                        ...newErrors,
                        [`automaticAppointment-${el.id}-triggerAfterDays-${entry.id}`]: {
                            error: true,
                            message: getReqMessage('Number of days')
                        },
                        [`accordion-${el.id}`]: { error: true }
                    };
                } else if (+entry.triggerAfterDays < 1) {
                    newErrors = {
                        ...newErrors,
                        [`automaticAppointment-${el.id}-triggerAfterDays-${entry.id}`]: {
                            error: true,
                            message: getNumMinMessage('Days')
                        },
                        [`accordion-${el.id}`]: { error: true }
                    };
                }
            });
        }
    });

    return newErrors;
};

export const configMissingDocumentTypes = (nonMatchingAppointmentTypes) => {
    let newWarnings = [];

    if (nonMatchingAppointmentTypes.length > 0) {
        return nonMatchingAppointmentTypes.map((el) => ({
            id: el.id,
            name: el.name
        }));
    }
    return newWarnings;
};
